<app-notifications></app-notifications>
<app-toasts></app-toasts>
<router-outlet></router-outlet>